import { googleMapsKey } from '../constants';

export const getGeocodeAddress = (google) => {
  const geocoder = new google.maps.Geocoder();
  return ({ address, location }, callback) => {
    geocoder.geocode({ address, location }, (res, status) => {
      if (status === 'OK') {
        const location = res[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();
        const address = res[0].formatted_address;
        callback({
          lat,
          lng,
          lon: lng,
          address,
        });
      } else {
        return callback(false);
      }
    });
  };
};

export const getCenter = (points, google) => {
  const bounds = new google.maps.LatLngBounds();
  points.forEach((point) => bounds.extend(point));
  const boundsCenter = bounds.getCenter();
  const center = {
    lat: boundsCenter.lat(),
    lng: boundsCenter.lng(),
  };
  return center;
};

export const loadGoogleMaps = (onLoad = () => {}) => {
  let googleMapsScript = document.head.querySelector(
    'script[src^="https://maps.google"]'
  );

  // Multiple components load Google maps so this makes sure we only load it once
  // if it's already loaded, call the onLoad callback
  // if it's not, but the script is on the page already, then listen for the load event on the script, then call onLoad
  // if it's not and there is no script on the page yet, add it and listen for the load event
  if (window.google) {
    onLoad();
  } else if (googleMapsScript) {
    googleMapsScript.addEventListener('load', onLoad);
    return () => googleMapsScript.removeEventListener('load', onLoad);
  } else {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?libraries=geometry&key=${googleMapsKey}`;
    document.head.append(script);
    script.addEventListener('load', onLoad);
    return () => script.removeEventListener('load', onLoad);
  }
};

export default loadGoogleMaps;
